import { Link } from "@remix-run/react";
import { Separator } from "./ui/separator";

export default function Footer() {
  return (
    <footer className="container flex flex-col justify-between gap-8 py-8 text-sm">
      <Separator />
      <div className="flex w-full flex-col items-center justify-between gap-4 md:flex-row">
        <div className="flex flex-col items-start items-center justify-between gap-4 md:flex-row md:gap-8">
          <img
            src="/logo-mark.svg"
            alt="low code plugins logo"
            className="h-8"
          />
          <div className="flex gap-4">
            <button
              onClick={() => $crisp?.push(["do", "chat:open"])}
              className="text-neutral-600 transition-colors hover:text-neutral-900"
            >
              Contact
            </button>
            <Link
              to="/terms"
              className="text-neutral-600 transition-colors hover:text-neutral-900"
            >
              Terms of Service
            </Link>
            <Link
              to="/privacy"
              className="text-neutral-600 transition-colors hover:text-neutral-900"
            >
              Privacy Policy
            </Link>
          </div>
        </div>

        <p className="text-center text-neutral-600">
          © 2024 Wise Growth Marketing LLC, dba Low Code Plugins.
        </p>
      </div>
    </footer>
  );
}
